<template>
  <div class="container login-success">
    <submit-header
      :headerConfig="headerConfig"
      @handleClickIocn="handleClickIocn"
    />
    <div class="main">
      <div class="tip-wrap">
        <success-tip :infoStyle="infoStyle" :info="info" />
      </div>

      <div>
        <el-button @click="getPaperInfo">显示投稿详情</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import submitHeader from "@/components/header"
  import successTip from "@/components/successTip"
  import store from "@/store"

  import CurrentConferMixin from "@/mixin/CurrentConference"
  import CurrentUserMixin from "@/mixin/CurrentUser"

  export default {
    name: "paperSubmitType",
    components: {
      submitHeader,
      successTip,
    },
    mixins: [CurrentConferMixin, CurrentUserMixin],
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-cuowu",
          headerTitle: "中国土木工程学会",
          color: "",
        },
        infoStyle: {
          color: "#f9000d",
        },
        isNeedExamine: true,
      }
    },

    computed: {
      info() {
        return "投稿成功，请等待审核!"
      },
    },

    created() {
      // this.getSignupList()
    },
    methods: {
      handleClickIocn() {
        //do something
        this.$router.push("/")
      },

      /* 跳转论文详情*/
      getPaperInfo() {
        console.log(this.$route.query.paper_id);
        this.$router.push({
          name: "paperDetails",
          query: { paper_id: this.$route.query.paper_id },
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    text-align: center;

    ::v-deep .el-button {
      position: relative;
      top: 150px;
      width: 80%;
      margin: 0 auto 15px;
      background: var(--main-color);
      color: #fff;

      &:hover {
        color: #fff;
      }

      &:focus {
        background: var(--main-color);
        border-color: #fff;
      }
    }
  }
</style>
